import {
  TextAction,
  HeadingText,
  Icon,
  Modal,
  ParagraphText,
  StackLayout,
  StackItem,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import React from 'react';
// import { SHARED_LIBRARY_ASSET_KEYS } from '@leagueplatform/engen-capability-shared-library/src/types/shared-library.types';
// import SuccessIcon from '@leagueplatform/engen-capability-shared-library/src/assets/success.svg';

export enum SHARED_LIBRARY_ASSET_KEYS {
  ATTENTION_ICON = 'ATTENTION_ICON',
  RIGHT_ARROW_ICON = 'RIGHT_ARROW_ICON',
  LEFT_ARROW_ICON = 'LEFT_ARROW_ICON',
  LEFT_ARROW_DISABLED_ICON = 'LEFT_ARROW_DISABLED_ICON',
  CROSS_ICON = 'CROSS_ICON',
  CALENDAR_ICON = 'CALENDAR_ICON',
  SUCCESS_ICON = 'SUCCESS_ICON',
  EXIT_WARNING = 'EXIT_WARNING',
}

function DynamicIcon(props: { type?: string }) {
  const { type } = props;

  const successIcon = useStaticAsset(SHARED_LIBRARY_ASSET_KEYS.SUCCESS_ICON);

  switch (type) {
    case 'Success':
      return <Icon size="55px" icon={successIcon as string} />;
    case 'Error':
      return (
        <Icon
          size="55px"
          icon="statusInformationCircleFill"
          tint="$criticalIcon"
        />
      );
    default:
      return (
        <Icon
          size="55px"
          icon="statusInformationCircleFill"
          tint="$primaryBackgroundDefault"
        />
      );
  }
}

function DynamicModalContent(props: {
  type?: string;
  title?: string;
  description?: string;
  buttonText?: string;
}) {
  const { type, title, description, buttonText } = props;

  function getDynamicTitle() {
    switch (type) {
      case 'Success':
        return 'Success';
      case 'Error':
        return 'Error';
      default:
        return '';
    }
  }

  function getDynamicDescription() {
    switch (type) {
      case 'Success':
        return 'Your changes have been saved.';
      case 'Error':
        return 'We were unable to save your changes. Please try again later.';
      default:
        return '';
    }
  }

  return (
    <StackLayout
      horizontalAlignment="center"
      spacing="$two"
      verticalAlignment="center"
      css={{
        margin: '$two $none',
        '@media only screen and (max-width: 400px) and (min-width: 320px)': {
          width: '85vw',
        },
        '@media only screen and (max-width: 480px) and (min-width: 401px)': {
          width: '90vw',
        },
      }}
    >
      <StackItem>
        <StackLayout
          horizontalAlignment="center"
          verticalAlignment="center"
          spacing="$one"
        >
          <DynamicIcon type={type} />
          <Modal.Title>
            <HeadingText
              level="1"
              size={{
                '@initial': 'xxl',
                '@mobile': 'xl',
              }}
            >
              {title || getDynamicTitle()}
            </HeadingText>
          </Modal.Title>
        </StackLayout>
      </StackItem>

      <Modal.Description>
        <ParagraphText css={{ textAlign: 'center' }}>
          {description || getDynamicDescription()}
        </ParagraphText>
      </Modal.Description>
      <Modal.Close>
        <TextAction as="button">{buttonText || 'OK'}</TextAction>
      </Modal.Close>
    </StackLayout>
  );
}

// TODO if possible build out a type that specifies when the parameters are required and not required
/*
  Rules:
    - if content is provided then type, title, description, buttonText will be ignored
    - if content is not provided, then type, title, description, and buttonText 
      will be used if a value is passed for those parameters, otherwise default behavior will be invoked
*/
export function NotificationModal(props: {
  modalOpen: boolean;
  onOpenChange: Function;
  type?: string;
  content?: any;
  title?: string;
  description?: string;
  buttonText?: string;
}) {
  const {
    modalOpen,
    onOpenChange,
    type,
    content,
    title,
    description,
    buttonText,
  } = props;
  return (
    <Modal.Root open={modalOpen} onOpenChange={() => onOpenChange()}>
      <Modal.Content
        width={{
          '@initial': '38%',
          '@laptop': '38%',
          '@mobileLandscape': '50%',
          '@tablet': '50%',
          '@mobile': '100%',
        }}
        css={{
          '.GDS-modal': {
            borderRadius: '$none',
            zIndex: '9999',
          },
          '.GDS-modal-overlay': {
            zIndex: '9999',
          },
          '.GDS-c-bVpebC-igUcHly-css': {
            margin: '0px',
          },
        }}
        onInteractOutside={(e) => e.preventDefault()}
        showCloseButton={false}
      >
        {content || (
          <DynamicModalContent
            type={type}
            title={title}
            description={description}
            buttonText={buttonText}
          />
        )}
      </Modal.Content>
    </Modal.Root>
  );
}
